module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/MC-9b3e677e82a72b4beb6bd538b0bb9d6f.svg";